import { createInstance, LOCALSTORAGE } from 'localforage';

const instance = createInstance({
  driver: LOCALSTORAGE,
});

export const localStorageClient = instance; 